var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "xp-badge",
      class: {
        "earned-zero-xp": _vm.xp === 0 && _vm.hasEarned,
        earned: _vm.xp !== 0 && _vm.hasEarned
      }
    },
    [
      _c("MeteorIcon", {
        attrs: {
          trailColor: _vm.meteorStrokeAndTrailColor,
          meteorColor: _vm.meteorColor,
          meteorStrokeColor: _vm.meteorStrokeAndTrailColor
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.xpDisplay))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }